// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { TextObject_abstract } from './../abstract/SagaBase/TextObject_abstract';
export class TextObject extends TextObject_abstract {}
